/* ============
 * Mutations for the service module
 * ============
 *
 */

import {
  SET_MOBILE_PORTRAIT,
  SET_OPT_OUT,
  SET_TOP_MENU,
} from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [SET_OPT_OUT](state, optOut) {
    state.optOut = typeof optOut === 'string' || optOut === null
      ? optOut !== 'false'
      : !!optOut;
  },
  [SET_MOBILE_PORTRAIT](state, value) {
    state.mobilePortrait = value;
  },
  [SET_TOP_MENU](state, value) {
    state.topmenu = !!value;
  },
  setTheme(state, value) {
    state.theme = value;
  },
  setRouteParams(state, value) {
    state.routeParams = value;
  },
  setExteriorNavBarVisible(state, value) {
    if (state.exteriorNavBarVisible !== value) {
      state.exteriorNavBarVisible = value;
    }
  },
  showMiniMap(state) {
      state.isMiniMapVisible = true;
  },
  hideMiniMap(state) {
      state.isMiniMapVisible = false;
  },
};
